import { Component, Input, OnInit } from "@angular/core";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";

@Component({
    selector: "app-tat-report",
    templateUrl: "./tat-report.component.html",
    styleUrls: ["./tat-report.component.scss"],
    standalone: false
})
export class TATReportComponent implements OnInit {
  @Input() loanId;
  TatReportsList: any;
  showSpinner: boolean;
  constructor(private _QuickLoanService: QuickLoanService) {}

  ngOnInit(): void {
    this._QuickLoanService
      .Quick_rpt_TAT_Report({ LoanId: this.loanId })
      .subscribe((res) => {
        this.TatReportsList = JSON.parse(JSON.stringify(res)).Item2;
        this.showSpinner = false;
        let sum = 0;
      });
  }
}
